import { axiosPrivate } from '../../api/axios';
import {
    NAV_NOTIFICATION_TYPES,
    NOTIFICATION_FILTERS,
    NOTIFICATIONS_PAGE_SIZE,
} from '../../common/notificationTypes';
import {
    setNotificationsLoading,
    setNotificationsLoadingMore,
    setNotifications,
    setNotificationsFilter,
    appendNotifications,
    markNotificationRead as markReadAction,
    markAllNotificationsRead as markAllReadAction,
    setNotificationPreferences,
} from '../reducers/notifications';

const NOTIFICATIONS_URL = '/api/chat-realtime/notifications';
const NAV_TYPES_PARAM = NAV_NOTIFICATION_TYPES.join(',');

const filterParams = (filter) => (
    filter === NOTIFICATION_FILTERS.read
        ? { readOnly: true }
        : { unreadOnly: true }
);

export const fetchNotifications = ({
    filter = NOTIFICATION_FILTERS.unread,
    limit = NOTIFICATIONS_PAGE_SIZE,
} = {}) => async (dispatch) => {
    const nextFilter = filter === NOTIFICATION_FILTERS.read
        ? NOTIFICATION_FILTERS.read
        : NOTIFICATION_FILTERS.unread;

    dispatch(setNotificationsFilter(nextFilter));
    dispatch(setNotificationsLoading(true));
    try {
        const response = await axiosPrivate.get(NOTIFICATIONS_URL, {
            params: {
                ...filterParams(nextFilter),
                limit,
                types: NAV_TYPES_PARAM,
            },
        });
        if (response.status === 200) {
            dispatch(setNotifications({
                ...response.data,
                filter: nextFilter,
            }));
        }
    } finally {
        dispatch(setNotificationsLoading(false));
    }
};

/** Siguiente página (5) al llegar al final de la pestaña activa. */
export const fetchMoreNotifications = () => async (dispatch, getState) => {
    const {
        hasMore,
        nextCursor,
        loadingMore,
        loading,
        filter,
    } = getState().notifications;
    if (!hasMore || !nextCursor || loadingMore || loading) return;

    dispatch(setNotificationsLoadingMore(true));
    try {
        const response = await axiosPrivate.get(NOTIFICATIONS_URL, {
            params: {
                ...filterParams(filter),
                limit: NOTIFICATIONS_PAGE_SIZE,
                cursor: nextCursor,
                types: NAV_TYPES_PARAM,
            },
        });
        if (response.status === 200) {
            dispatch(appendNotifications(response.data));
        }
    } finally {
        dispatch(setNotificationsLoadingMore(false));
    }
};

export const markNotificationAsRead = (notificationId) => async (dispatch) => {
    const response = await axiosPrivate.patch(
        `${NOTIFICATIONS_URL}/${notificationId}/read`,
    );
    if (response.status === 200) {
        dispatch(markReadAction(notificationId));
    }
};

export const markAllNotificationsAsRead = () => async (dispatch, getState) => {
    const { unreadCount } = getState().notifications;
    if (!unreadCount) return;

    dispatch(markAllReadAction());

    try {
        await axiosPrivate.patch(`${NOTIFICATIONS_URL}/read-all`);
    } catch {
        dispatch(fetchNotifications({
            filter: getState().notifications.filter,
        }));
    }
};

export const updateNotificationPreferences = (preferences) => async (dispatch) => {
    const response = await axiosPrivate.patch(
        `${NOTIFICATIONS_URL}/preferences`,
        preferences,
    );
    if (response.status === 200) {
        dispatch(setNotificationPreferences(response.data.notifications));
    }
};
